// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13yYW","left":"styles_left__H-6gz"};